// Contact data shown in the privacy notice and the dispute page.
// Set REACT_APP_CONTACT_EMAIL in Vercel to the inbox that answers privacy and dispute requests.
const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || 'santib99@icloud.com';
const PRIVACY_UPDATED = '28 de octubre de 2026';

export { CONTACT_EMAIL, PRIVACY_UPDATED };
